import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20251216_add_component_offset_z",
  description: "Add anchorZ property to all existing components",
  apply(json: any): any {
    const { components = {} } = json;

    // migrate components to use anchorZ
    for (const componentId in components) {
      components[componentId].anchorZ = 0;
    }

    return json;
  },
};

export default migration;
